var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getUrlParam('type') === 'check')?_c('div',{staticClass:"check-footer"},[_vm._v("当前为活动预览页，请分享发布后的活动页面~\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }